import { User } from './user.model';
import { Company } from './company.model';
import { CloudVendor } from './cloud-vendor.model';

export class RegisterAccountRequest {
    user: User;
    company: Company;
    authStateId: string;
    secondContactDetails: User;
    vendor: CloudVendor;
}
